export default __webpack_public_path__ + "static/media/checkbox-square-checked.f748ae43.svg";